
import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check, Minus } from "lucide-react";

import { cn } from "@/lib/utils";

interface CheckboxProps extends React.ComponentProps<typeof CheckboxPrimitive.Root> {
  indeterminate?: boolean;
}

function Checkbox({ className, indeterminate, checked, ...props }: Readonly<CheckboxProps>): React.ReactElement {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "peer h-4 w-4 shrink-0 rounded-sm border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 data-[state=checked]:bg-primary data-[state=checked]:text-background dark:border-input",
        "bg-white dark:bg-black",
        "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-muted/50 disabled:border-border/50",
        "data-[readonly]:bg-muted/50 data-[readonly]:cursor-default data-[readonly]:border-border/50 data-[readonly]:pointer-events-none",
        indeterminate && "bg-primary text-background",
        className,
      )}
      checked={indeterminate ? "indeterminate" : checked}
      {...props}
      data-oid="w2-0xmv"
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className={cn("flex items-center justify-center text-current")}
        data-oid="_1v77b0"
      >
        {indeterminate ? (
          <Minus className="h-3.5 w-3.5" data-oid="indeterminate-icon" />
        ) : (
          <Check className="h-3.5 w-3.5" data-oid="gc_u9_q" />
        )}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
